// extracted by mini-css-extract-plugin
module.exports = {"verticallyCenter":"verticallyCenter--1PuW_NUD","horizontalCenter":"horizontalCenter--2kznZTKW","main":"main--8dcqibpW"};